import { render, staticRenderFns } from "./laundrylist.vue?vue&type=template&id=673e37f2&scoped=true&"
import script from "./laundrylist.vue?vue&type=script&lang=js&"
export * from "./laundrylist.vue?vue&type=script&lang=js&"
import style0 from "./laundrylist.vue?vue&type=style&index=0&id=673e37f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673e37f2",
  null
  
)

export default component.exports